import React from 'react';

//Drag -beatutiful-dnd
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

//actions
import { basicMsg } from '../../../../actions/swal_msg';

//components
import ProductVariantBatch from './Batch/ProductVariantBatch';
import OdooStockSyncSwitch from '../OdooProduct/OdooStockSyncSwitch';

//constants
import { regex_dec, regex_num } from '../../../../constants/regex';

//MUI
import {
    FormControl, Select, InputAdornment, OutlinedInput, IconButton, Button, Box, TextField, Tooltip, FormGroup, Switch,
    FormControlLabel, Grid, MenuItem, Accordion, Typography, Divider,

} from '@mui/material';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import styled from '@emotion/styled';
import HelpIcon from '@mui/icons-material/Help';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { GOOGLE_DRIVE_CDN } from '../../../../constants/constants';

const Input = styled('input')({
    width: 100,
    display: 'none',
});

const NewVariant = ({
    pos,
    title,
    variant,
    setProdValues,
    onDeleteRemote
}) => {
    // valores de variante
    const {
        key, variant_title, price, description,
        stock, iva, sat_key, claveUnidad, unidad,
        barcode, odoo_id, sync_odoo_stock, available, images, batches
    } = variant;

    const label = `variant-contained-button-file-${key}`;

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;
        const items = Array.from(images);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        fnSetValues('images', items);
    };

    const handleInputChange = ({ target }) => {
        const name = target.name;
        const value = target.value;
        if (['iva', 'stock', 'sat_key', 'odoo_id'].includes(name)) {
            if (value === '' || regex_num.test(value))
                fnSetValues(name, value);
        } else if (name === 'price') {
            if (value === '' || regex_dec.test(value))
                fnSetValues(name, value);
        } else if (name === 'claveUnidad')
            fnSetValues(name, value.toUpperCase());
        else fnSetValues(name, value);
    };

    // setter
    const fnSetValues = (_name, _value) => {
        setProdValues(e => ({
            ...e,
            variants: e.variants.map(u =>
                (u.key === key) ?
                    { ...u, [_name]: _value } : u)
        }));
    };

    // ¿variante disponible?
    const handleSwitchChange = ({ target }) => {
        fnSetValues('available', target.checked);
    };

    // subir imágenes de ordenador
    const loadedImages = ({ target }) => {
        let count = images.length; // total de imágenes
        let exceeded = false; // se alcanzó el límite?
        if (count >= 6) {
            basicMsg('No puede agregar más imágenes en esta variante');
            return;
        }
        if (target.files.length > 0) {
            const target_files = [];
            [...target.files].forEach(element => {
                if (count >= 6) exceeded = true;
                else {
                    if (['image/jpeg', 'image/png', 'image/webp'].includes(element.type)) {
                        target_files.push({ img: element, alt: '' });
                        count++;
                    }
                }
            });
            setProdValues(prod => ({
                ...prod,
                variants: prod.variants.map(e =>
                    (e.key === key) ?
                        {
                            ...e,
                            images: [...e.images, ...target_files]
                        } : e
                )
            }));
            if (exceeded) basicMsg('Se alcanzó el límite de imágenes');
        }
    };

    // remueve imágenes de producto
    const removeImg = item => async() => {
        if (item.id && onDeleteRemote) {
            const removed = await onDeleteRemote(item.id);
            if (!removed)
                return;
        }
        setProdValues(prod => ({
            ...prod,
            variants: prod.variants.map(e =>
                (e.key === key) ?
                    {
                        ...e,
                        images: e.images.filter(i =>
                            (i.id || i.img?.name) !== (item.id || item.img?.name)
                        ),
                    } : e
            )
        }));
    };

    const deleteVariant = () => {
        setProdValues(prod => ({
            ...prod,
            variants: prod.variants.filter(e =>
                (e.key !== key)
            )
        }));
    };

    const handleAltChange = index => ({ target }) => {
        const alt = target.value;
        setProdValues(prod => ({
            ...prod,
            variants: prod.variants.map(e =>
                (e.key === key) ?
                    {
                        ...e,
                        images: e.images.map((u, i) => (i === index) ? {
                            ...u,
                            alt
                        } : u)
                    } : e
            )
        }));
    };

    return (
        <>
            <Accordion sx={{ boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header">
                    <Typography sx={{ fontWeight: 'bold' }}>
                        {
                            title !== '' ?
                                variant_title !== '' ?
                                    `Variante ${pos + 1} (${title} ${variant_title})`
                                    : `Variante ${pos + 1} (${title})`
                                :
                                variant_title !== '' ?
                                    `Variante ${pos + 1} (${variant_title})`
                                    : `Variante ${pos + 1}`
                        }
                    </Typography>
                </AccordionSummary>

                <AccordionDetails>

                    <Grid container spacing={3.5}>
                        <Grid item xs={12}>
                            <Typography variant='body2' sx={{ fontWeight: '600', color: '#707b7c' }} gutterBottom>Imágenes de la variante:</Typography>
                            <Box sx={{ mb: 3 }}>
                                <label htmlFor={label}>
                                    <Input accept="image/*"
                                        id={label}
                                        multiple
                                        type="file"
                                        onChange={loadedImages} />
                                    <Button
                                        style={{ backgroundColor: '#2699FB', color: 'white' }}
                                        variant="contained"
                                        component="span">
                                        Elegir imágenes
                                    </Button>
                                </label>
                            </Box>

                            <DragDropContext onDragEnd={handleOnDragEnd}>
                                <Droppable droppableId="images">
                                    {(provided) => (
                                        <Grid container spacing={4}
                                            {...provided.droppableProps} ref={provided.innerRef}>
                                            {images.map((item, index) => {
                                                const imageName = item.id
                                                    ? item.name || item.id
                                                    : item.img.name;
                                                const imageSrc = item.id
                                                    ? `${GOOGLE_DRIVE_CDN}${item.id}`
                                                    : URL.createObjectURL(item.img);
                                                return (
                                                    <Draggable key={imageName} draggableId={imageName}
                                                        index={index}>
                                                        {(prov) => (
                                                            <Grid item xxl={4} xl={4} lg={4} md={6} sm={6} xs={12}>
                                                                <Box sx={{ position: 'relative' }}
                                                                    ref={prov.innerRef}
                                                                    {...prov.draggableProps}
                                                                    {...prov.dragHandleProps}
                                                                >
                                                                    <Box
                                                                        component='img'
                                                                        src={imageSrc}
                                                                        alt={item.alt || imageName}
                                                                        sx={{
                                                                            width: '100%',
                                                                            height: 250,
                                                                            objectFit: 'cover',
                                                                        }}
                                                                    />
                                                                    <Box sx={{ position: 'absolute', top: 5, right: 5 }}>
                                                                        <IconButton onClick={removeImg(item)}
                                                                            sx={[
                                                                                {
                                                                                    '&:hover': {
                                                                                        backgroundColor: '#C11007',
                                                                                    },
                                                                                    backgroundColor: '#E7180B',
                                                                                    width: '35px',
                                                                                    height: '35px'
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <DeleteIcon sx={{ color: '#fff' }} fontSize='small' />
                                                                        </IconButton>
                                                                    </Box>
                                                                </Box>
                                                                <TextField
                                                                    fullWidth
                                                                    label="Atributo ALT"
                                                                    value={item.alt || ''}
                                                                    variant="standard"
                                                                    size="small"
                                                                    onChange={handleAltChange(index)}
                                                                />
                                                            </Grid>
                                                        )}
                                                    </Draggable>
                                                );
                                            })}
                                            {provided.placeholder}
                                        </Grid>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </Grid>

                        <Grid item xs={12}>
                            {
                                /* Identifica la variante del producto.
                                Utilícese cuando se desea ser específico en el nombre de producto */
                            }
                            <Typography variant='body2' sx={{ fontWeight: '600', color: '#707b7c' }} gutterBottom>Nombre de variante:</Typography>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                                <TextField
                                    name="variant_title"
                                    placeholder="Ejemplo: Sin refrigeración"
                                    variant="outlined"
                                    value={variant_title}
                                    inputProps={{ maxLength: 200 }}
                                    onChange={handleInputChange}
                                    sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, minWidth: '90%' }}
                                />
                                <Tooltip title="Utilice si desea especificar la variante de producto. Ejemplo: Sabor Fresa Alta Proteína">
                                    <IconButton>
                                        <HelpIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Grid>

                        <Grid item xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <Typography variant='body2' sx={{ fontWeight: '600', color: '#707b7c' }} gutterBottom>Precio de la variante:</Typography>
                            <FormControl fullWidth>
                                <OutlinedInput
                                    id="variant-input-price"
                                    name="price"
                                    placeholder="Precio"
                                    value={price}
                                    inputProps={{ maxLength: 8 }}
                                    onChange={handleInputChange}
                                    startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                    sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, }}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <Typography variant='body2' sx={{ fontWeight: '600', color: '#707b7c' }} gutterBottom>Código de barras:</Typography>
                            <TextField
                                fullWidth
                                name="barcode"
                                placeholder="Código de barras"
                                variant="outlined"
                                value={barcode}
                                inputProps={{ maxLength: 32 }}
                                onChange={handleInputChange}
                                sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant='body2' sx={{ fontWeight: '600', color: '#707b7c' }} gutterBottom>Descripción:</Typography>
                            <TextField
                                fullWidth
                                name="description"
                                placeholder="Descripción"
                                multiline
                                variant="outlined"
                                rows={4}
                                value={description}
                                inputProps={{ maxLength: 2000 }}
                                onChange={handleInputChange}
                                sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, }}
                            />
                        </Grid>

                        <Grid item xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <Typography variant='body2' sx={{ fontWeight: '600', color: '#707b7c' }} gutterBottom>Clave SAT:</Typography>
                            <TextField fullWidth
                                name="sat_key"
                                placeholder="Clave SAT"
                                variant="outlined"
                                value={sat_key}
                                inputProps={{ maxLength: 8 }}
                                onChange={handleInputChange}
                                sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, }}
                            />
                        </Grid>

                        <Grid item xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <Typography variant='body2' sx={{ fontWeight: '600', color: '#707b7c' }} gutterBottom>IVA:</Typography>
                            <FormControl fullWidth>
                                <Select
                                    labelId="iva-variant-label"
                                    name="iva"
                                    value={iva}
                                    placeholder="IVA"
                                    onChange={handleInputChange}
                                    sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, }}
                                >
                                    <MenuItem value={0}>0%</MenuItem>
                                    <MenuItem value={16}>16%</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <Typography variant='body2' sx={{ fontWeight: '600', color: '#707b7c' }} gutterBottom>Clave unidad:</Typography>
                            <TextField fullWidth
                                name="claveUnidad"
                                placeholder="Clave unidad"
                                variant="outlined"
                                value={claveUnidad}
                                inputProps={{ maxLength: 3 }}
                                onChange={handleInputChange}
                                sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, }}
                            />
                        </Grid>

                        <Grid item xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <Typography variant='body2' sx={{ fontWeight: '600', color: '#707b7c' }} gutterBottom>Unidad de medida:</Typography>
                            <TextField fullWidth
                                name="unidad"
                                placeholder="Unidad de medidad"
                                variant="outlined"
                                value={unidad}
                                inputProps={{ maxLength: 64 }}
                                onChange={handleInputChange}
                                sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant='body2' sx={{ fontWeight: '600', color: '#707b7c' }} gutterBottom>Cantidad disponible:</Typography>
                            <TextField
                                fullWidth
                                name="stock"
                                placeholder="Cantidad disponible"
                                variant="outlined"
                                value={stock}
                                inputProps={{ maxLength: 5 }}
                                onChange={handleInputChange}
                                sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant='body2' sx={{ fontWeight: '600', color: '#707b7c' }} gutterBottom>ID de producto en Odoo:</Typography>
                            <TextField
                                fullWidth
                                name="odoo_id"
                                placeholder="ID de producto en Odoo"
                                required={sync_odoo_stock}
                                variant="outlined"
                                value={odoo_id}
                                inputProps={{ maxLength: 32 }}
                                onChange={handleInputChange}
                                sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <OdooStockSyncSwitch
                                checked={sync_odoo_stock}
                                onChange={({ target }) =>
                                    fnSetValues('sync_odoo_stock', target.checked)
                                }
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            name="available"
                                            checked={available}
                                            onChange={handleSwitchChange} />
                                    }
                                    label="Mostrar en tienda" />
                            </FormGroup>
                        </Grid>
                    </Grid>

                    <Divider sx={{ my: 4, borderWidth: '.1rem' }} />

                    <ProductVariantBatch
                        variant_key={key}
                        batches={batches}
                        setProdValues={setProdValues}
                    />

                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            startIcon={<DeleteIcon />}
                            color='error'
                            onClick={deleteVariant}>
                            Eliminar variante
                        </Button>
                    </Box>
                </AccordionDetails>
            </Accordion>
        </>
    );
};

export default NewVariant;
